import {client} from './services/client'

export  const generalsettings = {
    namespaced:true,
    state:{
        generals:undefined,
        generalmarchands:undefined,
        showSelectMeanMethod:'',
        paid_by:'',
        manual_pay:'',

    },
    mutations: {
        SET_GEN (state,templates){
            state.generals = templates;
        },
        SET_GENM (state,templates){
            state.generalmarchands = templates;
        },
        SET_SHOWMEANMETHOD (state,value){
            state.showSelectMeanMethod = value;
        },
        SET_MANUAL_PAY (state,value){
            state.manual_pay = value;
        },
        SET_PAID_BY (state,value){
            state.paid_by = value;
        },
    },
    actions: {
        getGeneralSetting({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/generalsetting/get',
                })
                    .then((response)=>{
                        let datas = response.data.generalsettings;
                        commit('SET_GEN',datas);
                        let show = !datas.dpm && !datas.dpb;
                        commit('SET_SHOWMEANMETHOD',show);
                        let pay = !datas.dpqr?'qr':'manuel';
                        commit('SET_PAID_BY',pay);
                        let manual = '';
                        if (!datas.dpm && !datas.dpb){
                            manual='Mobile';
                        } else{
                            if (!datas.dpm){
                                manual='Mobile';
                            } else {
                                manual='Banque';
                            }
                        }
                        commit('SET_MANUAL_PAY',manual);
                        resolve(response.data)
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })
        },
        getGeneralSettingForMarchand({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/generalsetting/getGeneralSettingForMarchand',
                    data:data
                })
                    .then((response)=>{
                        let datas = response.data.generalsettings;
                        commit('SET_GEN',datas);
                        resolve(response.data)
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })
        },
        getGeneralSettingForMarchandDevise({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/generalsetting/getGeneralSettingForMarchandDevise',
                    data:data
                })
                    .then((response)=>{
                        let datas = response.data.generalsettings;
                        commit('SET_GEN',datas);
                        resolve(response.data)
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })
        },
        updateGeneralSetting({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/generalsetting/update',
                    data:data
                })
                    .then((response)=>{
                        let datas = response.data.generalsettings;
                        commit('SET_GEN',datas);
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        getGeneralSettingMarchand({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/generalsetting/marchand/get/'+id,
                })
                    .then((response)=>{
                        let datas = response.data.generalsettings;
                        commit('SET_GENM',datas);
                        resolve(response.data)
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })
        },
        updateGeneralSettingMarchand({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/generalsetting/marchand/update',
                    data:data
                })
                    .then((response)=>{
                        let datas = response.data.generalsettings;
                        commit('SET_GENM',datas);
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        setPaidBy({commit},status){
            commit('SET_PAID_BY',status);
        },
        setManualPay({commit},status){
            commit('SET_MANUAL_PAY',status);
        }

    },
    getters: {
        getCountries: state  => {
            return state.templates
        },
        getManualPay: state  => {
            return state.manual_pay
        },
        getPaidBy: state  => {
            return state.paid_by
        },
        getMeanMethod: state  => {
            return state.showSelectMeanMethod
        },
    }
};
